import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import MoreHorizontalIcon from '@mui/icons-material/MoreHoriz';
import { IconButton, Menu, MenuItem, Stack } from '@mui/material';
import { useId, useState } from 'react';

import { colors, isDefined } from 'common';

import { type KeyValueData } from './types';
import { useSelectedNodeField } from '../useSelectedNodeField';

interface BlockKeyValuesTableHeaderProps {
  fieldName: string;
  isFullScreen?: boolean;
  onToggleFullScreen: () => void;
  setIsConfirmationDialogOpen: (isOpen: boolean) => void;
}

export function BlockKeyValuesTableHeader(props: BlockKeyValuesTableHeaderProps) {
  const {
    fieldName,
    isFullScreen = false,
    onToggleFullScreen,
    setIsConfirmationDialogOpen,
  } = props;
  const { value } = useSelectedNodeField<KeyValueData[]>(fieldName);
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const isMenuOpen = isDefined(menuAnchor);

  const menuButtonId = useId();
  const menuId = useId();
  return (
    <Stack direction="row" spacing={1}>
      <IconButton
        onClick={() => {
          onToggleFullScreen();
          setMenuAnchor(null);
        }}
        aria-label={isFullScreen ? 'Close table' : 'Expand table'}
        size="small"
        sx={{ color: colors.extended.gray[55] }}
      >
        {isFullScreen ? (
          <FullscreenExitIcon fontSize="inherit" />
        ) : (
          <FullscreenIcon fontSize="inherit" />
        )}
      </IconButton>
      <IconButton
        aria-label="Show menu"
        id={menuButtonId}
        aria-controls={isMenuOpen ? menuId : undefined}
        aria-expanded={isMenuOpen ? 'true' : undefined}
        aria-haspopup="true"
        onClick={(event) => setMenuAnchor(event.currentTarget)}
        size="small"
      >
        <MoreHorizontalIcon />
      </IconButton>
      <Menu
        id={menuId}
        slotProps={{
          list: {
            'aria-labelledby': menuButtonId,
          },
        }}
        anchorEl={menuAnchor}
        open={isMenuOpen}
        onClose={() => {
          setMenuAnchor(null);
        }}
      >
        <MenuItem
          disabled={!isDefined(value) || value.length === 0}
          onClick={() => {
            setIsConfirmationDialogOpen(true);
            setMenuAnchor(null);
          }}
        >
          Clear all
        </MenuItem>
      </Menu>
    </Stack>
  );
}
